import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { HorizontalScroll } from "../horizontal-scroll";
import { Icon } from "../Icon";
import ProductCard from "../ProductCard";

type Props = {
  sections: CarouselExtended;
  head?: boolean;
};

const HomeCatalogDesktop: FunctionComponent<Props> = ({ sections, head }) => {
  const navigate = useNavigate();

  const categorie = (categorie: string) => {
    switch (categorie.toLocaleLowerCase()) {
      case "brazalete":
        return "Pulseras";
      case "chain":
        return "Cadenas";
      case "ring":
        return "Anillos";
      case "pendant":
        return "Dijes";
      case "hoop":
        return "Aros";
      case "finding":
        return "Fornituras";
      default:
        return "Accesorios";
    }
  };

  const translation = (categorie: string) => {
    if (
      categorie.toLocaleLowerCase() === "brazalete" ||
      categorie.toLocaleLowerCase() === "chain"
    )
      return "todas";
    else return "todos";
  };

  return (
    <section className="home_catalog_container">
      <section key={sections.name} className="catalog_category">
        {head && head == true ? (
          <></>
        ) : (
          <div className="catalog_ctas">
            <p className="catalog_title">{sections.label}</p>
            <p className="description_cta">En oro 18k y plata 925.</p>
            <button
              className="button_cta"
              onClick={() =>
                navigate(`/category/${sections.name.toLowerCase()}`)
              }
            >
              Ver {translation(sections.name)}{" "}
              <span>
                <Icon iconName="right_arrow" />
              </span>
            </button>
          </div>
        )}
        {sections.products.length > 0 && (
          <HorizontalScroll
            scrollBy={293}
            size={293}
            catalogScroll={true}
            items={sections.products.length}
          >
            <div className="category_scroll">
              {sections.products.map((p, index) => {
                return (
                  <ProductCard
                    title={p.productId?.title ?? ""}
                    key={p.productId?._id ?? index}
                    img={p.productId?.thumbnailUrl}
                    friendlyUrl={p.productId?.friendlyUrl}
                    sku={p.productId?.sku}
                  />
                );
              })}
            </div>
          </HorizontalScroll>
        )}
      </section>
    </section>
  );
};

export default HomeCatalogDesktop;
